import script from "./ClientRating.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientRating.vue?vue&type=script&setup=true&lang=js"

import "./ClientRating.vue?vue&type=style&index=0&id=065d5017&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-065d5017"]])

export default __exports__